module.exports = __webpack_public_path__ + "static/barrel-1f6d60e0b989f5f68210830237ca201d.mp4";